// src/home/index.js
import React, { useEffect, useState } from "react";

import baseURL from '../config';

const Home = () => {
  const [homeData, setHomeData] = useState(null);
  const [serviceData, setServiceData] = useState(null);
  
  document.title = "My First React Website";

  useEffect(() => {
    fetch(`${baseURL}/api/index/`)
      .then((res) => res.json())
      .then((data) => setHomeData(data))
      .catch((err) => console.error("Error:", err));

    fetch(`${baseURL}/api/services/`)
      .then((res) => res.json())
      .then((data) => setServiceData(data))
      .catch((err) => console.error("Error:", err));
  }, []);
 

  if (!homeData) return <div>Loading...</div>;

  return (
    <div>
      {/* ✅ Banner */}
      <section>
        <div>
          <img
            src={homeData.banner.backgroundImage}
            alt="Banner"
            style={{
              width: "100%",
              height: "500px",
              objectFit: "cover",
            }}
          />
        </div>
      </section>

       
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center mb-4">Our Services</h2>
          <div className="row justify-content-center g-4">
            {serviceData?.map((service, index) => (
              <div className="col-md-4" key={index}>
              <div className="card h-100 shadow-sm">
                  <div className="card-body text-center">
                    <div style={{ fontSize: "30px" }}>{service.icon}</div>
                    <h5 className="card-title mt-3">{service.title}</h5>
                    <p className="card-text text-muted">{service.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
